/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unloadChatbot } from '../../lib/store/chatbot/actions';
import { disableNavigation, enableNavigation, requestNavigation, failedNavigation } from '../../lib/store/navigation/actions';
import fetchChatbotConfig from './fetch-chatbot-config';
import addChatbotFrame from './add-chatbot-frame';
import '../wfui-bridge/WFUIBridge.less';

var ChatBot = function ChatBot(_ref) {
  var openModal = _ref.openModal;
  var dispatch = useDispatch();
  var failedNavigationItemId = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.navigation.failedNavigationItemId;
  });
  useEffect(function () {
    window.WF_CHATBOT = window.WF_CHATBOT || {};
    window.WF_CHATBOT.initBot = window.WF_CHATBOT.initBot ? window.WF_CHATBOT.initBot : function () {
      fetchChatbotConfig().then(function (result) {
        addChatbotFrame(result);
      });
    };
    window.WF_CHATBOT.navigate = window.WF_CHATBOT.navigate ? window.WF_CHATBOT.navigate : function (navigationItem) {
      return dispatch(requestNavigation(navigationItem));
    };
    window.WF_CHATBOT.unloadChatbot = window.WF_CHATBOT.unloadChatbot ? window.WF_CHATBOT.unloadChatbot : function () {
      return dispatch(unloadChatbot());
    };
    window.WF_CHATBOT.enableNavigation = window.WF_CHATBOT.enableNavigation ? window.WF_CHATBOT.enableNavigation : function () {
      return dispatch(enableNavigation());
    };
    window.WF_CHATBOT.disableNavigation = window.WF_CHATBOT.disableNavigation ? window.WF_CHATBOT.disableNavigation : function () {
      return dispatch(disableNavigation());
    };
    window.WF_CHATBOT.sendNavigationError = window.WF_CHATBOT.sendNavigationError ? window.WF_CHATBOT.sendNavigationError : function (failedNavigationItemId) {
      window.WFUI_BRIDGE.postMessageToChildren(window.WF_CHATBOT.uuid, {
        type: 'error',
        payload: failedNavigationItemId
      });
    };
    window.WF_CHATBOT.openModal = openModal;
    window.WF_CHATBOT.initBot();
  }, [dispatch, openModal]);

  if (failedNavigationItemId) {
    window.WF_CHATBOT.sendNavigationError(failedNavigation);
  }

  return null;
};

export default ChatBot;